var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "border card-form mb-3"
  }, [_c('b-row', {
    staticClass: "p-3"
  }, [_c('b-col', {
    staticClass: "d-flex flex-column align-self-end",
    attrs: {
      "md": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "kind-fleet"
    }
  }, [_vm._v("Fleet Name *")]), _c('v-multiselect', {
    attrs: {
      "multiple": false,
      "track-by": "id",
      "placeholder": "Select fleet",
      "options": _vm.fleetTypeOpt,
      "label": "name",
      "value": "id",
      "id": "kind-fleet"
    },
    model: {
      value: _vm.form.vehicle_type_ids,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "vehicle_type_ids", $$v);
      },
      expression: "form.vehicle_type_ids"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Consider changing the search query.")])])], 1), _c('b-col', {
    staticClass: "d-flex flex-column mt-3",
    attrs: {
      "md": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "input-year"
    }
  }, [_vm._v("Year *")]), _c('date-picker', {
    staticClass: "w-100",
    attrs: {
      "id": "input-year",
      "type": "year"
    },
    model: {
      value: _vm.form.year,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "year", $$v);
      },
      expression: "form.year"
    }
  })], 1), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, _vm._l(_vm.form.target_per_months, function (plans, index) {
    return _c('b-row', {
      key: index,
      staticClass: "mt-2"
    }, [_c('b-col', {
      attrs: {
        "md": "12"
      }
    }, [_c('h6', {
      staticClass: "text-sm text-primary font-weight-bold text-uppercase"
    }, [_vm._v(_vm._s(_vm.moment().month(index).format('MMMM')))])]), _c('b-col', {
      staticClass: "d-flex flex-column",
      attrs: {
        "md": "3"
      }
    }, [_c('label', {
      attrs: {
        "for": "input-availability-".concat(index)
      }
    }, [_vm._v("Plan Availability *")]), _c('b-input-group', {
      attrs: {
        "append": "%"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "input-availability-".concat(index),
        "type": "number"
      },
      on: {
        "blur": function blur(event) {
          return _vm.handleValidateTargetAvailability(event, index, 'availability');
        }
      },
      model: {
        value: plans.plan_availability,
        callback: function callback($$v) {
          _vm.$set(plans, "plan_availability", _vm._n($$v));
        },
        expression: "plans.plan_availability"
      }
    })], 1), _c('b-form-invalid-feedback', {
      attrs: {
        "state": plans.error_availability
      }
    }, [_vm._v(" Target tidak boleh melebihi dari 100%. ")])], 1), _c('b-col', {
      staticClass: "d-flex flex-column",
      attrs: {
        "md": "3"
      }
    }, [_c('label', {
      attrs: {
        "for": "input-breakdown-".concat(index)
      }
    }, [_vm._v("Plan Breakdown *")]), _c('b-input-group', {
      attrs: {
        "append": "%"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "input-breakdown-".concat(index),
        "type": "number"
      },
      on: {
        "blur": function blur(event) {
          return _vm.handleValidateTargetAvailability(event, index, 'breakdown');
        }
      },
      model: {
        value: plans.plan_breakdown,
        callback: function callback($$v) {
          _vm.$set(plans, "plan_breakdown", _vm._n($$v));
        },
        expression: "plans.plan_breakdown"
      }
    })], 1), _c('b-form-invalid-feedback', {
      attrs: {
        "state": plans.error_breakdown
      }
    }, [_vm._v(" Target tidak boleh melebihi dari 100%. ")])], 1), _c('b-col', {
      staticClass: "d-flex flex-column",
      attrs: {
        "md": "3"
      }
    }, [_c('label', {
      attrs: {
        "for": "input-docking-".concat(index)
      }
    }, [_vm._v("Plan Docking *")]), _c('b-input-group', {
      attrs: {
        "append": "%"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "input-docking-".concat(index),
        "type": "number"
      },
      on: {
        "blur": function blur(event) {
          return _vm.handleValidateTargetAvailability(event, index, 'docking');
        }
      },
      model: {
        value: plans.plan_docking,
        callback: function callback($$v) {
          _vm.$set(plans, "plan_docking", _vm._n($$v));
        },
        expression: "plans.plan_docking"
      }
    })], 1), _c('b-form-invalid-feedback', {
      attrs: {
        "state": plans.error_docking
      }
    }, [_vm._v(" Target tidak boleh melebihi dari 100%. ")])], 1), _c('b-col', {
      staticClass: "d-flex flex-column",
      attrs: {
        "md": "3"
      }
    }, [_c('label', {
      attrs: {
        "for": "input-total-".concat(index)
      }
    }, [_vm._v("Total")]), _c('b-input-group', {
      attrs: {
        "append": "%"
      }
    }, [_c('b-form-input', {
      attrs: {
        "id": "input-total-".concat(index),
        "type": "number",
        "value": _vm.getTotal(plans),
        "disabled": ""
      }
    })], 1), _c('b-form-invalid-feedback', {
      attrs: {
        "state": plans.error_total
      }
    }, [_vm._v(" Total harus mencapai 100%. ")])], 1)], 1);
  }), 1), _c('b-col', {
    staticClass: "d-flex flex-column my-3",
    attrs: {
      "md": "12"
    }
  }, [_c('label', {
    attrs: {
      "for": "input-remarks"
    }
  }, [_vm._v("Remarks")]), _c('b-form-textarea', {
    attrs: {
      "id": "input-remarks",
      "placeholder": "Enter something...",
      "rows": "3",
      "max-rows": "6"
    },
    model: {
      value: _vm.form.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "remark", $$v);
      },
      expression: "form.remark"
    }
  })], 1), _c('b-col', {
    staticClass: "d-flex justify-content-end my-3",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-primary",
      "outline": ""
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(" Cancle and Close ")]), !_vm.loading ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "outline": ""
    },
    on: {
      "click": function click() {
        return _vm.handleSubmit();
      }
    }
  }, [_vm._v(" Submit ")]) : _c('b-button', {
    staticClass: "d-flex align-items-center px-3",
    attrs: {
      "variant": "primary",
      "outline": ""
    }
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }